import { controllingSetOpenOptions, controllingSetTransformArea } from '../../store/controlling/actions';
import tripleLayerSvg from '../Menu/assets/layer-2.svg';
import styles from './SecondaryMenu.module.scss';
import clearSvg from './assets/clear.svg';
import fitToScreenSvg from './assets/fitToScreen.svg';
import logoSvg from './assets/logo.svg';
import moreSvg from './assets/more.svg';
import oneToOneSvg from './assets/oneToOne.svg';
import moveSvg from './assets/zoom.svg';
import cn from 'classnames';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SecondaryMenu = ({ engine }) => {
  const dispatch = useDispatch();
  const [more, setMore] = useState(false);

  const presetName = useSelector((s) => {
    return s.controlling.defaultPresets && s.controlling.presetType ? s.controlling.defaultPresets[s.controlling.presetType] : undefined;
  });

  const { layersType } = useSelector((s) => s.controlling);

  return (
    <>
      <div className={styles.container}>
        <div
          className={styles.logo}
          onClick={() => {
            dispatch(controllingSetOpenOptions(true));
          }}
        >
          <img src={logoSvg} alt="Glaze" />
        </div>

        <ul>
          <div className={styles.separator} />

          <li
            onClick={() => {
              setMore((m) => !m);
            }}
          >
            <div className={cn(styles.icon, more && styles.rotated)}>
              <img src={moreSvg} alt="more" />
            </div>
          </li>

          {more && (
            <>
              <div className={styles.separator} />

              <li>
                <div className={styles.layer}>
                  <img src={tripleLayerSvg} alt="Layers" />
                  <span>{layersType}</span>
                </div>
              </li>

              <div className={styles.separator} />

              <li>
                <div className={styles.tooltip}>{presetName}</div>
              </li>

              <div className={styles.separator} />

              <li
                onClick={() => {
                  engine.clearWetScreen();
                }}
              >
                <div className={cn(styles.icon)}>
                  <img src={clearSvg} alt="clear" />
                </div>
              </li>

              <li
                onClick={() => {
                  engine.fitToNaturalScale();
                }}
              >
                <div className={cn(styles.icon)}>
                  <img src={oneToOneSvg} alt="fit to natural scale" />
                </div>
              </li>

              <li
                onClick={() => {
                  engine.fitToScreen();
                }}
              >
                <div className={cn(styles.icon)}>
                  <img src={fitToScreenSvg} alt="fit to screen" />
                </div>
              </li>
            </>
          )}

          <div className={styles.separator} />

          <li
            onClick={() => {
              dispatch(controllingSetTransformArea(true));
            }}
          >
            <div className={cn(styles.icon)}>
              <img src={moveSvg} alt="move" />
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default SecondaryMenu;
